interface StatusBadgeProps {
  status: string
  variant?: 'success' | 'warning' | 'info' | 'error' | 'default' | 'brand'
  size?: 'sm' | 'md' | 'lg'
}

const variantColors = {
  brand: {
    bg: 'rgba(0, 136, 204, 0.2)',
    border: 'rgba(0, 136, 204, 0.4)',
    text: 'rgb(56, 189, 248)',
  },
  success: {
    bg: 'rgba(34, 197, 94, 0.2)',
    border: 'rgba(34, 197, 94, 0.4)',
    text: 'rgb(74, 222, 128)',
  },
  warning: {
    bg: 'rgba(234, 179, 8, 0.2)',
    border: 'rgba(234, 179, 8, 0.4)',
    text: 'rgb(250, 204, 21)',
  },
  info: {
    bg: 'rgba(0, 136, 204, 0.2)',
    border: 'rgba(0, 136, 204, 0.4)',
    text: 'rgb(56, 189, 248)',
  },
  error: {
    bg: 'rgba(239, 68, 68, 0.2)',
    border: 'rgba(239, 68, 68, 0.4)',
    text: 'rgb(248, 113, 113)',
  },
  default: {
    bg: 'rgba(128, 128, 128, 0.2)',
    border: 'rgba(128, 128, 128, 0.3)',
    text: 'rgb(156, 163, 175)',
  },
}

const sizeStyles = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-3 py-1',
  lg: 'text-base px-4 py-1.5',
}

/**
 * Reusable status badge component for displaying status indicators.
 * Supports different variants (colors) and sizes.
 * 
 * @example
 * <StatusBadge status="Active" variant="success" />
 * <StatusBadge status="Pending" variant="warning" size="sm" />
 */
export function StatusBadge({ 
  status, 
  variant = 'default', 
  size = 'md' 
}: StatusBadgeProps) {
  const colors = variantColors[variant]
  
  return (
    <span 
      className={`inline-flex items-center rounded-full font-medium ${sizeStyles[size]}`}
      style={{
        backgroundColor: colors.bg,
        border: `1px solid ${colors.border}`,
        color: colors.text,
      }}
    >
      {status}
    </span>
  )
}
